import { CreateSubjectRequest } from '@src/main/modules/messages/infrastructure/dto/createSubjectRequest';
import { createSubjectHttpRepository } from '@src/main/modules/messages/infrastructure/repository/SubjectHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const createSubjectUseCase = async (
  data: CreateSubjectRequest,
  tokenProvider: TokenProvider,
) => {
  const repository = createSubjectHttpRepository(tokenProvider);
  return await repository.create(data);
};
